import { inject, Injectable, Injector } from '@angular/core';
import { Contract } from '@common/core/models';
import { IBitfApiRequest } from '@common/interfaces';
import { BitfApiService } from '@common/libs/bitforce/core/services/api/bitf-api.service';
import { StoreService } from '../store.service';

const CONTRACT_DETAILS_POPULATE = {
  attachments: {
    populate: '*',
  },
  revenues: {
    populate: '*',
  },
  invoices: {
    populate: '*',
  },
  workOrders: {
    populate: {
      purchaseRequests: {
        populate: {
          entryGoods: true,
          workOrder: true,
        },
      },
    },
  },
  contractParent: {
    fields: ['id', 'documentId', 'contractName', 'contractId'],
  },
  convention: {
    fields: ['id', 'documentId', 'nameAqConvention'],
  },
};

@Injectable({
  providedIn: 'root',
})
export class ContractsService extends BitfApiService {
  /**
   * Imports
   */
  storeService = inject(StoreService);

  constructor(public injector: Injector) {
    super('contracts', injector);
  }

  getContracts(apiRequest: IBitfApiRequest) {
    return this.get<Contract>({
      populate: '*',
      filter: {
        company: {
          documentId: { $in: this.storeService.store?.group?.companies?.map(c => c.documentId) },
        },
        ...apiRequest.filter,
      },
      ...apiRequest,
    });
  }

  getContractDetails(id: string) {
    return this.getById<Contract>({
      id: id,
      populate: CONTRACT_DETAILS_POPULATE,
    });
  }

  updateContract(contract: Contract) {
    return this.put({
      id: contract.documentId,
      body: contract.serialised,
      populate: CONTRACT_DETAILS_POPULATE,
    });
  }

  getAllTags() {
    return this.get<Contract>({
      fields: 'tags',
      filter: {
        company: {
          documentId: { $in: this.storeService.store?.group?.companies?.map(c => c.documentId) },
        },
        tags: { $notNull: true, $ne: '' },
      },
    });
  }

  getAllNsoCodes() {
    return this.get<Contract>({
      fields: 'nso',
      filter: {
        company: {
          documentId: { $in: this.storeService.store?.group?.companies?.map(c => c.documentId) },
        },
        nso: { $notNull: true, $ne: '' },
      },
    });
  }
}
